export default {
  name: 'WModal',
  props: {
    hideCloseButton: {
      default: false,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    showFooter: {
      default: true,
      type: Boolean,
    },
    showHeader: {
      default: true,
      type: Boolean,
    },
    value: {
      default: false,
      type: Boolean,
    },
    variant: String,
  },
  data() {
    return {
      open: false,
    };
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.open = newVal;
      }
    },
  },
  created() {
    this.open = this.value;
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
